// tree = {
// 	init() {
// 		$(document).on('click', '.js-tree li', function(e) {
// 			e.stopPropagation();
//
// 			let
// 				$li = $(event.currentTarget),
// 				$child = $li.find('> ul'),
// 				height = 0;
//
// 			if (!$child.length) return false;
//
// 			if ($li.hasClass('closed')) {
// 				$child.css('height', 'auto');
//
// 				height = $child.height();
// 				$child.height(0);
//
// 				$child.animate({height: height}, 200, function() {
// 					$child.css('height', 'auto');
// 					$li.removeClass('closed');
// 				});
// 			}
//
// 			else {
// 				$child.animate({
// 					height: 0
// 				}, 200);
//
// 				$li.addClass('closed');
// 			}
// 		});
// 	}
// }

$(document).ready(function () {
	// tree.init();

	$(document).on('click', '.js-tree li', function (e) {
		e.stopPropagation();

		let $li = $(this),
			$child = $li.children('ul');

		if (!$child.length) return false;

		if ($li.hasClass('closed')) {
			$child.slideDown();
			$li.removeClass('closed');
		}
		else {
			$child.slideUp();
			$li.addClass('closed');
		}

	});
});